export function shouldRenderDiv(value: string | undefined) {
  return typeof value !== "undefined" && value;
}

export function addHeaderTagIfMissing(htmlContent: string, tag: string) {
  if (htmlContent.startsWith("<h")) {
    return htmlContent;
  }

  return `<${tag}>${htmlContent}</${tag}>`;
}
